module.exports = {
          srcSet: __webpack_public_path__ + "14989d7cd8e91711fd357224150ce308-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "14989d7cd8e91711fd357224150ce308-2336.png",width: 2336,height: 468}],
          src: __webpack_public_path__ + "14989d7cd8e91711fd357224150ce308-2336.png",
          toString:function(){return __webpack_public_path__ + "14989d7cd8e91711fd357224150ce308-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AFZoUP1seV3/Y3lf/l58Zf9RdWL/U2Za/3lGQ/9fWUv+WHJW/zhcSvsAR19I/WBuUf9SaVD+RGNQ/ydaSP9rSkP/mElK/0VSRP5BXET/MFdG+5SjKGk4N2hJAAAAAElFTkSuQmCC",
          width: 2336,
          height: 468
        }